(() => {
  console.info('[GHALIA] pdp-tisento-set bundle-pilot v18');
  const pricing = () => window.GhaliaPricing;
  const formatNet = (netCents) =>
    pricing()?.formatNet(netCents) ?? (Number(netCents) / 100).toFixed(2);

  const tisentoMsg = (root, key, fallback = '') =>
    (root && root.dataset && root.dataset[key]) || fallback;

  const INFINITY_BRIDGE = 'infinity-bridge-ring';
  const INFINITY_PAVE = 'single-infinity-pave-ring';
  const BUNDLE_HANDLES = window.GhaliaNativeBundleHandles
    ? Array.from(window.GhaliaNativeBundleHandles)
    : [
        'ghalia-infinity-ring-duo',
        'knot-bridge-duo-silver',
        'knot-bridge-duo-gold',
        'ghalia-knot-hero-set-gold',
        'ghalia-knot-hero-set-silver',
        'ghalia-knot-two-tone-ring-stack',
        'ghalia-knot-wrist-story',
        'ghalia-pave-gold-stack',
        'ghalia-pave-silver-stack',
        'ghalia-cross-ring-earring-gold',
      ];

  const bundleVariantCache = new Map();

  const normalizeSize = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const normalizeOptionName = (value) => String(value || '').toLowerCase().trim();

  const euFromOptionString = (value) => {
    const s = String(value || '');
    const euTag = s.match(/\(EU\)\s*(\d{2})/i);
    if (euTag) return euTag[1];
    const nums = s.match(/\b(4[7-9]|5[0-9]|6[01])\b/g);
    if (nums?.length) return nums[nums.length - 1];
    return normalizeSize(s);
  };

  const rowRingEu = (row) => {
    const input = row.querySelector('[data-tisento-size]:checked');
    return normalizeSize(input?.dataset?.sizeEu || '');
  };

  const rowSizeOptionName = (row) => {
    const group = row.querySelector('[data-tisento-size-group]');
    return normalizeOptionName(group?.dataset?.sizeOptionName || '');
  };

  const stackRequiresBundleSku = (root) => {
    const members = (root?.dataset?.stackMembers || '')
      .split(',')
      .map((h) => h.trim())
      .filter(Boolean);
    return members.includes(INFINITY_BRIDGE) && members.includes(INFINITY_PAVE);
  };

  const parseVariants = (row) => {
    const raw = row.querySelector('[data-tisento-variants]');
    if (!raw) return [];
    try {
      return JSON.parse(raw.textContent || '[]');
    } catch {
      return [];
    }
  };

  const getFormContext = () => {
    const form = document.querySelector('[data-product-form]');
    if (!form) return [];
    const productJson = form.querySelector('[data-product-json]');
    let product = null;
    try {
      product = productJson ? JSON.parse(productJson.textContent) : null;
    } catch {
      product = null;
    }
    if (!product?.options?.length) return [];
    return product.options.map((name) => {
      const input = form.querySelector(`[data-option-input][name="options[${CSS.escape(name)}]"]:checked`);
      return input ? String(input.value || '').trim() : '';
    });
  };

  const getPinnedContext = (row, variants, sizeIdx) => {
    if (row.hasAttribute('data-tisento-anchor')) {
      const formCtx = getFormContext();
      const fallback = variants.find((v) => v.available) || variants[0];
      return (fallback?.options || []).map((opt, idx) => {
        if (idx === sizeIdx) return '';
        return formCtx[idx] || String(opt || '');
      });
    }
    const fallback = variants.find((v) => v.available) || variants[0];
    return (fallback?.options || []).map((opt, idx) => (idx === sizeIdx ? '' : String(opt || '')));
  };

  const resolveVariant = (row) => {
    const variants = parseVariants(row);
    if (!variants.length) return null;
    const sizeInput = row.querySelector('[data-tisento-size]:checked');
    if (rowNeedsSize(row) && !sizeInput) return null;
    const sizeValue = sizeInput?.dataset.sizeValue || sizeInput?.value || '';
    const sizeGroup = row.querySelector('[data-tisento-size-group]');
    const sizeIdx = sizeGroup ? Number(sizeGroup.dataset.sizeOptionIndex) : -1;
    const pinned = getPinnedContext(row, variants, sizeIdx);

    const match = variants.find((variant) => {
      if (!variant.available) return false;
      const opts = variant.options || [];
      if (sizeValue) {
        if (sizeIdx >= 0) {
          if (String(opts[sizeIdx] || '') !== sizeValue) return false;
        } else if (!opts.some((opt) => String(opt) === sizeValue)) {
          return false;
        }
      }
      return opts.every((opt, idx) => {
        if (idx === sizeIdx) return true;
        const pin = pinned[idx];
        if (!pin) return true;
        return String(opt) === pin;
      });
    });

    return match || variants.find((v) => v.available) || variants[0] || null;
  };

  const applyVariantToRow = (row) => {
    const variant = resolveVariant(row);
    if (!variant) return null;
    const priceEl = row.querySelector('[data-tisento-row-price]');
    if (priceEl) priceEl.textContent = formatNet(Number(variant.price || 0));
    const soloBtn = row.querySelector('[data-tisento-add-one]');
    if (soloBtn && variant.id) soloBtn.dataset.variantId = String(variant.id);
    return variant;
  };

  const getRowVariantId = (row) => {
    const variant = resolveVariant(row);
    return variant?.id ? String(variant.id) : '';
  };

  const getRowPrice = (row) => {
    const variant = resolveVariant(row);
    if (variant?.price) return Number(variant.price);
    const variants = parseVariants(row);
    const fallback = variants.find((v) => v.available) || variants[0];
    return Number(fallback?.price || 0);
  };

  const rowRingSize = (row) => {
    const input = row.querySelector('[data-tisento-size]:checked');
    return normalizeSize(input?.dataset?.sizeValue || input?.value || '');
  };

  const rowNeedsSize = (row) => Boolean(row.querySelector('[data-tisento-size-group]'));

  const rowSizeChosen = (row) => {
    if (!rowNeedsSize(row)) return true;
    return row.dataset.tisentoSizeChosen === 'true' && Boolean(rowRingSize(row));
  };

  const sizeValueFromForm = (row) => {
    const sizeGroup = row.querySelector('[data-tisento-size-group]');
    if (!sizeGroup) return '';
    const sizeIdx = Number(sizeGroup.dataset.sizeOptionIndex);
    const formCtx = getFormContext();
    if (sizeIdx >= 0 && formCtx[sizeIdx]) return String(formCtx[sizeIdx]).trim();
    return '';
  };

  const checkRowSizeInput = (row, sizeValue) => {
    if (!sizeValue) return false;
    const inputs = row.querySelectorAll('[data-tisento-size]');
    for (const input of inputs) {
      const candidate = input.dataset.sizeValue || input.value || '';
      if (String(candidate) === String(sizeValue)) {
        if (!input.checked) input.checked = true;
        row.dataset.tisentoSizeChosen = 'true';
        return true;
      }
    }
    return false;
  };

  const syncAnchorRowFromForm = (root) => {
    const anchor = root?.querySelector('[data-tisento-anchor]');
    if (!anchor || !rowNeedsSize(anchor)) return;
    const formSize = sizeValueFromForm(anchor);
    if (!formSize) return;
    if (checkRowSizeInput(anchor, formSize)) applyVariantToRow(anchor);
  };

  const syncFormFromAnchorRow = (row, sizeValue) => {
    if (!row.hasAttribute('data-tisento-anchor') || !sizeValue) return;
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    const sizeGroup = row.querySelector('[data-tisento-size-group]');
    const sizeIdx = sizeGroup ? Number(sizeGroup.dataset.sizeOptionIndex) : -1;
    const productJson = form.querySelector('[data-product-json]');
    let product = null;
    try {
      product = productJson ? JSON.parse(productJson.textContent) : null;
    } catch {
      product = null;
    }
    const optionName = product?.options?.[sizeIdx];
    if (!optionName) return;
    const formInput = form.querySelector(
      `[data-option-input][name="options[${CSS.escape(optionName)}]"][value="${CSS.escape(sizeValue)}"]`
    );
    if (formInput && !formInput.checked) {
      formInput.checked = true;
      formInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const handleSizeSelection = (input) => {
    const root = input.closest('[data-pdp-tisento]');
    const row = input.closest('[data-tisento-row]');
    if (!row) return;
    row.dataset.tisentoSizeChosen = 'true';
    applyVariantToRow(row);
    if (row.hasAttribute('data-tisento-anchor')) {
      syncFormFromAnchorRow(row, input.dataset.sizeValue || input.value || '');
    }
    if (root) updateSetTotals(root);
  };

  const expandSoloMode = (root) => {
    if (!root || root.classList.contains('is-solo-expanded')) return;
    setSoloExpanded(root, true);
  };

  const ensureSizesForCompleteSet = (root) => {
    const rows = root.querySelectorAll('[data-tisento-row]');
    const missing = Array.from(rows).filter((row) => !rowSizeChosen(row));
    if (!missing.length) return true;
    setStatus(
      root,
      tisentoMsg(root, 'msgChooseSizeEach', 'Please choose a size for each piece before adding the set.'),
      true
    );
    if (window.matchMedia('(max-width: 1024px)').matches) {
      missing[0]?.querySelector('[data-tisento-size-group]')?.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
        inline: 'nearest',
      });
    }
    return false;
  };

  const inferBundleMode = (variants, root) => {
    const explicit = root?.dataset?.bundleMode;
    if (explicit === '2d' || explicit === 'single' || explicit === 'multi') return explicit;
    if (variants.some((v) => Array.isArray(v.componentSizes) && v.componentSizes.length > 2)) {
      return 'multi';
    }
    if (!variants.length) return 'none';
    if (variants.some((v) => normalizeSize(v.bridgeSize) !== normalizeSize(v.paveSize))) {
      return '2d';
    }
    const paveSizesByBridge = new Map();
    variants.forEach((v) => {
      const bridge = normalizeSize(v.bridgeSize);
      if (!paveSizesByBridge.has(bridge)) paveSizesByBridge.set(bridge, new Set());
      paveSizesByBridge.get(bridge).add(normalizeSize(v.paveSize));
    });
    for (const paveSizes of paveSizesByBridge.values()) {
      if (paveSizes.size > 1) return '2d';
    }
    return 'single';
  };

  const readBundleVariantIndex = (root) => {
    const el = root?.querySelector('[data-bundle-variant-index]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch {
      return null;
    }
  };

  const readBundleVariants = (root) => {
    const el = root?.querySelector('[data-bundle-variants]');
    if (!el) return { variants: [], mode: 'none' };
    try {
      const variants = JSON.parse(el.textContent || '[]');
      return { variants, mode: inferBundleMode(variants, root) };
    } catch {
      return { variants: [], mode: 'none' };
    }
  };

  const mapProductVariants = (variants, root) => {
    if (!variants.length) return { variants: [], mode: 'none' };
    const explicit = root?.dataset?.bundleMode;
    if (explicit === 'multi' || (variants[0]?.option3 != null && variants[0]?.option3 !== undefined)) {
      const mapped = variants.map((v) => ({
        id: v.id,
        price: v.price,
        componentSizes: [v.option1, v.option2, v.option3].filter((x) => x != null && x !== ''),
      }));
      return { mode: 'multi', variants: mapped };
    }
    const mapped = variants.map((v) => ({
      id: v.id,
      price: v.price,
      bridgeSize: v.option1 || '',
      paveSize: v.option2 || v.option1 || '',
    }));
    return { mode: inferBundleMode(mapped, root), variants: mapped };
  };

  const isNativeBundleRoot = (root) =>
    root?.dataset?.hasBundleSku === 'true' ||
    root?.dataset?.bundleMode === 'multi' ||
    root?.dataset?.bundleMode === '2d' ||
    root?.dataset?.bundleMode === 'single';

  const fetchBundleVariants = async (root) => {
    const embedded = readBundleVariants(root);
    if (embedded.variants.length) return embedded;

    const preferred = root?.dataset?.bundleProductHandle?.trim();
    const bundleMode = root?.dataset?.bundleMode || '';
    const rootUrl = window.Shopify?.routes?.root || '/';

    const fetchHandle = async (handle) => {
      if (!handle) return null;
      const cacheKey = `${handle}:${bundleMode || 'auto'}`;
      if (bundleVariantCache.has(cacheKey)) return bundleVariantCache.get(cacheKey);
      const res = await fetch(`${rootUrl}products/${handle}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return null;
      const data = await res.json();
      const rawVariants = data?.variants || data?.product?.variants || [];
      const mapped = mapProductVariants(rawVariants, root);
      if (mapped.variants.length) {
        bundleVariantCache.set(cacheKey, mapped);
        return mapped;
      }
      return null;
    };

    if (preferred) {
      const preferredData = await fetchHandle(preferred);
      if (preferredData) return preferredData;
    }

    for (const handle of BUNDLE_HANDLES) {
      if (handle === preferred) continue;
      const mapped = await fetchHandle(handle);
      if (mapped) return mapped;
    }

    return { variants: [], mode: 'none' };
  };

  const sizeValuesMatch = (a, b) => {
    if (!a || !b) return false;
    if (normalizeSize(a) === normalizeSize(b)) return true;
    const euA = euFromOptionString(a);
    const euB = euFromOptionString(b);
    return Boolean(euA && euB && euA === euB);
  };

  const bundleVariantForRows = (root, rows, bundleData) => {
    const { variants, mode } = bundleData;
    if (!variants.length) return null;

    if (mode === 'multi') {
      const order = (root?.dataset?.componentOrder || '')
        .split(',')
        .map((h) => h.trim())
        .filter(Boolean);
      if (!order.length) return null;

      const sizesByHandle = new Map();
      rows.forEach((row) => {
        const handle = row.dataset.productHandle || '';
        const size = rowRingSize(row);
        const eu = rowRingEu(row);
        if (handle && size) sizesByHandle.set(handle, { size, eu });
      });
      if (order.some((handle) => !sizesByHandle.has(handle))) return null;

      const index = readBundleVariantIndex(root);
      if (index && typeof index === 'object') {
        const key = order
          .map((handle) => {
            const pick = sizesByHandle.get(handle);
            return pick?.eu || euFromOptionString(pick?.size) || '';
          })
          .join('|');
        const indexedId = index[key];
        if (indexedId) return Number(indexedId);
      }

      const rowMatchesComponent = (rowPick, componentValue) => {
        if (!rowPick || !componentValue) return false;
        if (sizeValuesMatch(rowPick.size, componentValue)) return true;
        if (rowPick.eu && sizeValuesMatch(rowPick.eu, componentValue)) return true;
        const compEu = euFromOptionString(componentValue);
        return Boolean(rowPick.eu && compEu && rowPick.eu === compEu);
      };

      const match = variants.find((v) => {
        const componentSizes = v.componentSizes || [];
        if (componentSizes.length !== order.length) return false;
        return order.every((handle, idx) =>
          rowMatchesComponent(sizesByHandle.get(handle), componentSizes[idx])
        );
      });
      return match?.id ? Number(match.id) : null;
    }

    const bridgeOpt = normalizeOptionName(root?.dataset?.bridgeOption || 'Bridge ring size');
    const paveOpt = normalizeOptionName(root?.dataset?.paveOption || 'Pave ring size');

    let bridgeSize = '';
    let paveSize = '';

    rows.forEach((row) => {
      const handle = row.dataset.productHandle || '';
      const size = rowRingSize(row);
      if (!size) return;
      const rowOpt = rowSizeOptionName(row);

      if (handle === INFINITY_BRIDGE) bridgeSize = size;
      else if (handle === INFINITY_PAVE) paveSize = size;
      else if (rowOpt && bridgeOpt && rowOpt === bridgeOpt) bridgeSize = size;
      else if (rowOpt && paveOpt && rowOpt === paveOpt) paveSize = size;
    });

    if (!bridgeSize || !paveSize) {
      const anchor = root.dataset.stackAnchor || '';
      rows.forEach((row) => {
        const handle = row.dataset.productHandle || '';
        const size = rowRingSize(row);
        if (!size) return;
        if (handle === anchor) bridgeSize = bridgeSize || size;
        else paveSize = paveSize || size;
      });
    }

    if (mode === 'single') {
      const sizedRows = Array.from(rows).filter(rowNeedsSize);
      const euSizes = sizedRows.map(rowRingEu).filter(Boolean);
      const rawSizes = sizedRows.map(rowRingSize).filter(Boolean);
      if (!euSizes.length && !rawSizes.length) return null;
      const uniqueEu = [...new Set(euSizes)];
      const uniqueRaw = [...new Set(rawSizes.map(normalizeSize))];
      if (uniqueEu.length > 1 || (!euSizes.length && uniqueRaw.length > 1)) {
        return { error: 'same-size' };
      }
      const pickEu = uniqueEu[0] || '';
      const pickRaw = uniqueRaw[0] || '';
      bridgeSize = pickEu || pickRaw;
      paveSize = bridgeSize;
    } else if (!bridgeSize || !paveSize) {
      return null;
    }

    const match = variants.find((v) => {
      if (mode === '2d') {
        return normalizeSize(v.bridgeSize) === bridgeSize && normalizeSize(v.paveSize) === paveSize;
      }
      const vEu = euFromOptionString(v.bridgeSize);
      if (bridgeSize && vEu && /^\d{2}$/.test(bridgeSize)) {
        return vEu === bridgeSize;
      }
      return normalizeSize(v.bridgeSize) === bridgeSize;
    });

    return match?.id ? Number(match.id) : null;
  };

  const updateSetTotals = async (root) => {
    const rows = root.querySelectorAll('[data-tisento-row]');
    const bundleData = await fetchBundleVariants(root);
    const bundleResult = bundleVariantForRows(root, rows, bundleData);
    const bundleId = typeof bundleResult === 'object' ? null : bundleResult;
    const bundleMatch = bundleData.variants.find((v) => Number(v.id) === bundleId);

    const netPrices = [];
    rows.forEach((row) => netPrices.push(getRowPrice(row)));
    const pct = Number(root.dataset.discountPct || 0);
    const P = pricing();
    let compareNet = P?.sumNet ? P.sumNet(netPrices) : netPrices.reduce((a, b) => a + b, 0);
    let totalNet =
      pct > 0 && P?.applyDiscount
        ? P.applyDiscount(compareNet, pct)
        : pct > 0
          ? Math.round((compareNet * (100 - pct)) / 100)
          : compareNet;

    if (bundleMatch) {
      const bundlePrice = Number(bundleMatch.price) || 0;
      totalNet = bundlePrice > 0 && bundlePrice < compareNet ? bundlePrice : totalNet;
    }

    const compareEl = root.querySelector('[data-tisento-compare]');
    const totalEl = root.querySelector('[data-tisento-total]');
    if (compareEl) compareEl.textContent = formatNet(compareNet);
    if (totalEl) totalEl.textContent = formatNet(totalNet);
  };

  const setStatus = (root, message, isError = false) => {
    const note = root?.querySelector('[data-tisento-status]');
    if (!note) return;
    note.textContent = message || '';
    note.dataset.state = isError ? 'error' : message ? 'ok' : '';
  };

  const refreshRoot = (root) => {
    root.querySelectorAll('[data-tisento-row]').forEach(applyVariantToRow);
    updateSetTotals(root);
  };

  const stackLineProperties = (root) => {
    const anchor = root?.dataset?.stackAnchor || '';
    const pct = root?.dataset?.discountPct || '';
    const members = root?.dataset?.stackMembers || '';
    if (!anchor || !pct || !members) return null;
    return {
      _ghalia_stack_anchor: anchor,
      _ghalia_stack_pct: String(pct),
      _ghalia_stack_members: members,
      _ghalia_bundle_line: 'true',
    };
  };

  const rowItemsForCompleteSet = (root, rows) => {
    const props = stackLineProperties(root);
    const items = [];
    rows.forEach((row) => {
      const id = getRowVariantId(row);
      if (!id) return;
      items.push({
        id: Number(id),
        quantity: 1,
        ...(props ? { properties: { ...props } } : {}),
      });
    });
    return items;
  };

  const addItems = async (items, trigger) => {
    if (!items.length) throw new Error('No variants selected');
    const payload = items.map((item) => {
      if (typeof item === 'object' && item != null && 'id' in item) {
        const row = { id: Number(item.id), quantity: Number(item.quantity || 1) };
        if (item.properties && Object.keys(item.properties).length) {
          row.properties = item.properties;
        }
        return row;
      }
      return { id: Number(item), quantity: 1 };
    });
    if (window.GhaliaCart?.addItems) {
      return window.GhaliaCart.addItems(payload, trigger, { openCart: true });
    }
    if (window.GhaliaCartApi?.addItem) {
      return window.GhaliaCartApi.addItem({ items: payload });
    }
    throw new Error('Could not add to bag');
  };

  const addCompleteSet = async (root, btn) => {
    if (!ensureSizesForCompleteSet(root)) return;

    root.querySelectorAll('[data-tisento-row]').forEach(applyVariantToRow);
    const rows = root.querySelectorAll('[data-tisento-row]');
    if (!rows.length) return;

    const requiresBundle = stackRequiresBundleSku(root);
    const bundleData = readBundleVariants(root);
    const bundleResolved =
      bundleData.variants.length > 0 ? bundleData : await fetchBundleVariants(root);
    const nativeBundle = isNativeBundleRoot(root);
    const hasBundle =
      requiresBundle ||
      nativeBundle ||
      bundleResolved.variants.length > 0;
    const bundleResult = bundleVariantForRows(root, rows, bundleResolved);
    const bundleVariantId = typeof bundleResult === 'number' ? bundleResult : null;

    if (hasBundle && !bundleVariantId) {
      console.warn('[GHALIA] bundle variant not found', {
        mode: root.dataset.bundleMode,
        order: root.dataset.componentOrder,
        variantCount: bundleResolved.variants.length,
      });
      if (bundleResolved.variants.length === 0) {
        setStatus(
          root,
          tisentoMsg(
            root,
            'msgBundleUnpublished',
            'Bundle product is not published on the store. Publish the bundle set in Shopify Admin.'
          ),
          true
        );
      } else {
        setStatus(
          root,
          tisentoMsg(
            root,
            'msgSizeUnavailable',
            'This size combination is not available as a set. Try different sizes.'
          ),
          true
        );
      }
      return;
    }

    btn.setAttribute('aria-busy', 'true');
    setStatus(root, '');
    try {
      if (bundleVariantId) {
        console.info('[GHALIA] adding native bundle variant', bundleVariantId);
        if (window.GhaliaCart?.addVariant) {
          await window.GhaliaCart.addVariant(bundleVariantId, {
            openCart: true,
            trigger: btn,
            skipStockCheck: true,
          });
        } else {
          await addItems([{ id: bundleVariantId, quantity: 1 }], btn);
        }
      } else if (nativeBundle) {
        setStatus(
          root,
          tisentoMsg(
            root,
            'msgSizeUnavailable',
            'This size combination is not available as a set. Try different sizes.'
          ),
          true
        );
        return;
      } else {
        const items = rowItemsForCompleteSet(root, rows);
        if (items.length !== rows.length) {
          setStatus(root, tisentoMsg(root, 'msgChooseSize', 'Please choose a size for each piece.'), true);
          return;
        }
        await addItems(items, btn);
      }
      setStatus(root, '');
    } catch (err) {
      console.error(err);
      setStatus(root, err.message || tisentoMsg(root, 'msgAddSetError', 'Could not add set'), true);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  };

  const addSingleRow = async (row, btn) => {
    const variant = applyVariantToRow(row);
    if (!variant?.id) {
      const root = row.closest('[data-pdp-tisento]');
      setStatus(root, tisentoMsg(root, 'msgChooseSize', 'Please choose a size.'), true);
      return;
    }
    btn.setAttribute('aria-busy', 'true');
    try {
      if (window.GhaliaCart?.addVariant) {
        await window.GhaliaCart.addVariant(Number(variant.id), { openCart: true, trigger: btn });
      } else {
        await addItems([String(variant.id)], btn);
      }
    } catch (err) {
      console.error(err);
      const root = row.closest('[data-pdp-tisento]');
      setStatus(root, err.message || tisentoMsg(root, 'msgAddItemError', 'Could not add item'), true);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  };

  const setSoloExpanded = (root, expanded) => {
    if (!root) return;
    const toggle = root.querySelector('[data-tisento-toggle-solo]');
    root.classList.toggle('is-solo-expanded', expanded);
    if (toggle) {
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      const expandLabel = toggle.dataset.labelExpand || '';
      const collapseLabel = toggle.dataset.labelCollapse || '';
      toggle.textContent = expanded ? collapseLabel || toggle.textContent : expandLabel || toggle.textContent;
    }
    root.querySelectorAll('[data-tisento-row]').forEach((row) => {
      row.classList.toggle('is-solo-visible', expanded);
    });
    root.querySelectorAll('.pdp-tisento__row-actions--solo').forEach((el) => {
      el.hidden = !expanded;
    });
  };

  const bind = () => {
    document.querySelectorAll('[data-pdp-tisento]').forEach((root) => {
      setSoloExpanded(root, root.classList.contains('is-solo-expanded'));
      syncAnchorRowFromForm(root);
      refreshRoot(root);
    });

    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-tisento-size]');
      if (input) {
        handleSizeSelection(input);
        return;
      }

      if (e.target.matches('[data-option-input]')) {
        document.querySelectorAll('[data-pdp-tisento]').forEach((root) => {
          syncAnchorRowFromForm(root);
          updateSetTotals(root);
        });
      }
    });

    document.addEventListener('click', (e) => {
      const pill = e.target.closest('.pdp-tisento__sizes .option-pill--pdp');
      if (pill) {
        const label = pill.closest('label');
        const input = label?.querySelector('[data-tisento-size]');
        if (input && !input.disabled) {
          if (!input.checked) input.checked = true;
          handleSizeSelection(input);
        }
        return;
      }

      const soloBtn = e.target.closest('[data-tisento-add-one]');
      if (soloBtn) {
        e.preventDefault();
        const row = soloBtn.closest('[data-tisento-row]');
        if (row) addSingleRow(row, soloBtn);
        return;
      }

      const toggle = e.target.closest('[data-tisento-toggle-solo]');
      if (toggle) {
        const root = toggle.closest('[data-pdp-tisento]');
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        setSoloExpanded(root, !expanded);
        return;
      }

      const btn = e.target.closest('[data-tisento-add-complete]');
      if (!btn) return;
      e.preventDefault();
      const root = btn.closest('[data-pdp-tisento]');
      if (root) addCompleteSet(root, btn);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
